import { ComponentStyleConfig } from '@chakra-ui/react';

export const SelectStyles: ComponentStyleConfig = {
  variants: {
    pagination: (_props) => {
      return {
        field: {
          pl: 2,
          pr: '1.25rem',
          border: 'solid 1px',
          borderColor: 'border.1',
          '&&': {
            borderRadius: '8px',
            outlineOffset: 0,
          },
          _focusVisible: {
            outlineColor: 'state.selected',
          },
        },
        icon: {
          w: 'auto',
        },
      };
    },
  },
};
